"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const Resource_1 = __importDefault(require("../../Resource"));
const SubPatrimoineCompositionResponseResource_1 = __importDefault(require("./Patrimoine/SubPatrimoineCompositionResponseResource"));
const SubPatrimoineOrigineResponseResource_1 = __importDefault(require("./Patrimoine/SubPatrimoineOrigineResponseResource"));
const SubRevenusCompositionResponseResource_1 = __importDefault(require("./Patrimoine/SubRevenusCompositionResponseResource"));
const SubRevenuChargeResponseResource_1 = __importDefault(require("./Patrimoine/SubRevenuChargeResponseResource"));
const SubPatrimoineCompositionCorporationResponseResource_1 = __importDefault(require("./Patrimoine/SubPatrimoineCompositionCorporationResponseResource"));
const SubSituationFinanciereCorporationResponseResource_1 = __importDefault(require("./Patrimoine/SubSituationFinanciereCorporationResponseResource"));
const SubRevenusCompositionCorporationResponseResource_1 = __importDefault(require("./Patrimoine/SubRevenusCompositionCorporationResponseResource"));
class GenericPatrimoineResponseResource extends Resource_1.default {
}
exports.default = GenericPatrimoineResponseResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "hexaPillar2Q1a", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "hexaPillar2Q2a", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "hexaPillar2Q2b", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "hexaPillar2Q2c", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "hexaPillar2Q2d", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "hexaPillar2Q2e", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "hexaPillar2Q2f", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "hexaPillar2Q3a", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "hexaPillar2Q3b", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "hexaPillar2AccountingStandards", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "hexaPillar2ExclusionBasis", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "beneficieConventionsFiscales", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "nbEnfantsACharge", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "dontEnfantsACharge", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "montantImpotAnneePrecedente", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "trancheMarginaleImposition", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "montantIFIAnneePrecedente", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "situationPatrimoniale", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "patrimoine", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => SubPatrimoineCompositionResponseResource_1.default),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "compositionPatrimoine", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => SubPatrimoineOrigineResponseResource_1.default),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "originePatrimoine", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "revenusAnnuelsBrutsFoyer", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => SubRevenusCompositionResponseResource_1.default),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "compositionRevenus", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "capaciteEpargneMensuelle", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "investissementPatrimoineGlobal", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "montantGlobalPretRembourser", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "loyerOuCreditMensuel", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "creditImmobilierInvestissementLocatif", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "creditConsommation", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => SubRevenuChargeResponseResource_1.default),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "revenuCharge", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "tauxEndettement", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "chargesAnnuellesFoyerFiscal", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "beneficieConventionsFiscalesCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "nbSalariesCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "secteurActiviteCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "montantImpotAnneePrecedenteCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "montantIFIAnneePrecedenteCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "patrimoineCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SubPatrimoineCompositionCorporationResponseResource_1.default),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "compositionPatrimoineCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SubSituationFinanciereCorporationResponseResource_1.default),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "situationFinanciereCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], GenericPatrimoineResponseResource.prototype, "originePatrimoineCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "revenusAnnuelsBrutsCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SubRevenusCompositionCorporationResponseResource_1.default),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "compositionRevenusSocieteCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "situationFinancierePermetPlacerCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "montantPermetPlacerCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "partInvestissementPatrimoineGlobalCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "chargeEmpruntImmobilierAnnuelleCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "chargeAutreEmpruntAnnuelleCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "categorisationMifCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "societeCoteeCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "societeListeeCodeMonetaireCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "societeListeeCodeMonetaireCorporationPrecision", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "societeUsPersonCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "statutFactaCrsCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "detientPlusDroitsVoteCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "activeEnDehorsUeCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericPatrimoineResponseResource.prototype, "paysActifEnDehorsUeCorporation", void 0);
